import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'customCurrency',
  standalone: false,
})
export class CustomCurrencyPipe implements PipeTransform {
  constructor(private cPipe: CurrencyPipe) {}

  transform(value: number | string): string | null {
    if (!value) {
      return '0';
    }
    value =
      typeof value === 'number' ? value : parseFloat(value.replace('$', ''));
    return this.cPipe.transform(value);
  }
}
